import { Input, RadioGroup, SubmitButton } from '@panwds/react-form';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslate } from "../../customHooks";
import { toast } from '../../components';
import getUrlParameter from "../../utils/GetUrlParameter";
import styles from './styles/Register.module.scss';
import { authProvider, oktaProvider } from '../../authProvider';
import { RouteUri } from '../../routeUri';
import { useHistory } from 'react-router-dom';
import { composeValidators, isBlockedDomain, isEmail, isRequired } from '../../utils/validate';
import { useValidateAssociationCodeMutation } from '../../redux/services/validate-scm-code-service';
import CircularLoader from '../../components/CircularLoader/CircularLoader';
import queryString from "query-string";
import { SUBSCRIPTION_ACCOUNT_STATUS } from '../../utils/constants';

export const SubscriptionAccountLinked = (props: any) => {
    const translate = useTranslate();
    const history = useHistory();
    const ACCOUNT_ID = getUrlParameter("acc-id");
    const [triggerValidateScmCode, { isLoading: validatingScmCode }] = useValidateAssociationCodeMutation();
    const queryParams = queryString.parse(window?.location?.search);
    const ONBOARDED_ACCOUNT = queryParams['link-state'] === SUBSCRIPTION_ACCOUNT_STATUS.ASSOCIATE_SUCCESS;

    const formMethods = useForm({});
    const {
        formState: { isValid }, watch
    } = formMethods

    const handleSubmit = async (params: any = {}) => {
        if (params.BillingAssociationCode) {
            try {
                const isValidScmCode = await triggerValidateScmCode({
                    payload: {
                        UserEmail: params?.UserName,
                        BillingAccessCode: params?.BillingAssociationCode,
                        AWSAccountID: params?.AccountId
                    }
                }).unwrap();
                if (isValidScmCode) {
                    const options = {
                        state: {
                            ...(queryString?.parse(window?.location?.search)),
                            ...(params?.BillingAssociationCode && { BillingAssociationCode: params.BillingAssociationCode })
                        },
                        loginHint: params?.UserName
                    };
                    oktaProvider.signIn(options);
                }
            } catch (err) {
                toast.error(err?.error, { toastId: "validate-scm-code" });
            }
        } else {
            if (ONBOARDED_ACCOUNT) {
                const options = {
                    state: queryParams,
                    loginHint: params?.UserName
                };
                oktaProvider.signIn(options);
            } else {
                await authProvider.logout(null);
                history.push(RouteUri.Login);
            }
        }
    };
    const hasCode = watch("HasBillingAssociationCode");

    return (
        <>
            {validatingScmCode && <CircularLoader loading={true} />}
            <div className='formLayout'>
                <span className="tw-text-sm">{translate("acctLinked.subTitle")}</span>
                <span className="tw-text-xs tw-mb-2">{translate("acctLinked.description")}</span>
            </div>
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
                    <div className='formLayout'>
                        <Input
                            name="AccountId"
                            label={translate("generic.awsAccountId")}
                            dataMetrics="cloudngfw-sign-up-first-name"
                            requiredAsterisk
                            value={ACCOUNT_ID}
                            readOnly
                        />

                        <RadioGroup horizontal
                            label={translate(`auth.haveBillingAssociationCode`)}
                            name="HasBillingAssociationCode"
                            dataMetrics={"cloudngfw-sign-up-has-billing-association-code"}
                            requiredAsterisk
                            tooltip={translate("auth.billingAssociationCodeTooltip")}
                            items={[{
                                value: 'Yes',
                                children: translate('generic.yes'),
                            }, {
                                value: 'No',
                                children: translate('generic.no'),
                            }]}
                        />

                        {(hasCode === "No" && ONBOARDED_ACCOUNT) &&
                            <Input
                                name="UserName"
                                type="email"
                                label={translate("auth.email")}
                                dataMetrics="cloudngfw-sign-up-email"
                                requiredAsterisk
                                register={{
                                    validate: (value) => composeValidators(isRequired, isBlockedDomain, isEmail)(value)
                                }}
                            />
                        }

                        {hasCode === "Yes" &&
                            <>
                                <Input
                                    name="UserName"
                                    type="email"
                                    label={translate("auth.email")}
                                    dataMetrics="cloudngfw-sign-up-email"
                                    requiredAsterisk
                                    register={{
                                        validate: (value) => composeValidators(isRequired, isBlockedDomain, isEmail)(value)
                                    }}
                                />
                                <Input
                                    name="BillingAssociationCode"
                                    label={translate("auth.billingAssociationCode")}
                                    dataMetrics="cloudngfw-scm-sign-up-billing-code"
                                    requiredAsterisk
                                />
                            </>
                        }

                        {/* {hasCode === "No" &&
                            <div>
                                <div>
                                    <b><span className="tw-text-sm">{translate(`acctLinked.subTitle`)}</span></b>
                                    <span className={`subTitle tw-pt-2 tw-text-sm`}>{translate(`acctLinked.description`)}</span>
                                </div>
                                <div>

                                </div>
                            </div>
                        } */}

                        <SubmitButton addClassName={styles.customButton} disabled={!isValid}>{translate(`generic.continue`)}</SubmitButton>
                    </div>
                </form>
            </FormProvider>
        </>
    );
};
